import React from "react";

const IstarDelete = () => {
    return (
        <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center p-4">
            <div className="bg-white shadow-md rounded-lg p-8 w-full max-w-lg">
                <h1 className="text-2xl font-bold mb-4">Account Deletion Request</h1>
                <p className="mb-4 text-gray-700">
                    To request that your account and associated data is deleted, please follow the steps below. This link is provided by Atticus Labs.
                </p>
                <h2 className="text-xl font-semibold mb-2">Steps to Request Account Deletion:</h2>
                <ol className="list-decimal list-inside mb-4 text-gray-700">
                    <li>
                        Click the "Delete Account" link below.
                    </li>
                    <li>
                        Confirm that you wish to have your account and data removed.
                    </li>
                    <li>
                        Review the details regarding data deletion and retention.
                    </li>
                </ol>
                <h2 className="text-xl font-semibold mb-2">Data Deletion Details:</h2>
                <ul className="list-disc list-inside mb-4 text-gray-700">
                    <li>
                        Personal information and profile data will be permanently deleted.
                    </li>
                    <li>
                        Usage analytics may be retained for up to 12 months for ongoing improvement of our services.
                    </li>
                    <li>
                        Financial transactions are preserved in compliance with legal obligations.
                    </li>
                </ul>
                <button
                    // href="https://your-account-deletion-url.com"
                    className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition"
                >
                    Delete Account
                </button>
            </div>
        </div>
    );
};

export default IstarDelete;